export enum CurrencyCode {
	BTC = "BTC",
	CZK = "CZK",
	EUR = "EUR",
	USD = "USD",
	GBP = "GBP",
	PLN = "PLN",
	CHF = "CHF",
}

/** Space reserved at the bottom of a screen for the native bottom bar + safe-area inset. */
export const NATIVE_BOTTOM_BAR_SPACING =
	"var(--mobile-bottom-inset, calc(104px + env(safe-area-inset-bottom, 34px)))";
